import { api } from './cliente.js';
import type { TransicaoDisponivel } from './tipos.js';

export type EstadoPrograma = 'EmDefinicao' | 'Ativo' | 'EmRisco' | 'Suspenso' | 'Cancelado' | 'EmRealizacaoBeneficio' | 'Concluido';

export interface Programa {
  id: string;
  nome: string;
  responsavel: string;
  estado: EstadoPrograma;
  prazoRealizacaoCiclos: number;
  criadoPor: string;
  criadoEm: string;
}

export interface Dependencia {
  id: string;
  programaId: string;
  projetoOrigemId: string;
  entregaOrigem: string;
  projetoDestinoId: string;
  tipo: 'bloqueante' | 'informativa' | 'recurso_compartilhado';
  dataCritica: string;
}

export interface GrafoPrograma {
  arestas: Dependencia[];
  caminhoCritico: string[];
}

export const ESTADOS_PROGRAMA: EstadoPrograma[] = ['EmDefinicao', 'Ativo', 'EmRealizacaoBeneficio', 'Concluido'];

export type EstadoBeneficio = 'Declarado' | 'EmMedicao' | 'Realizado' | 'NaoRealizadoAceito';

export interface Beneficio {
  id: string;
  descricao: string;
  dono: string;
  metaDescricao: string | null;
  metaValor: number | null;
  estado: EstadoBeneficio;
  contextoTipo: 'projeto' | 'programa';
  contextoId: string;
  decisaoAceite: string | null;
  criadoPor: string;
  criadoEm: string;
}

export const programasApi = {
  listar: () => api.get<Programa[]>('/programas'),
  buscar: (id: string) => api.get<Programa>(`/programas/${id}`),
  grafo: (id: string) => api.get<GrafoPrograma>(`/programas/${id}/grafo`),
  beneficios: (id: string) => api.get<Beneficio[]>(`/programas/${id}/beneficios`),
  transicoesDisponiveis: (id: string) => api.get<TransicaoDisponivel[]>(`/programas/${id}/transicoes`),
  transicionar: (id: string, evento: string) => api.post(`/programas/${id}/transicoes`, { evento }),
};

export const beneficiosApi = {
  medir: (id: string, valor: number) => api.post(`/beneficios/${id}/medicoes`, { valor }),
  realizar: (id: string) => api.post(`/beneficios/${id}/realizar`),
  aceitarNaoRealizado: (id: string, decisao: string) => api.post(`/beneficios/${id}/aceitar-nao-realizado`, { decisao }),
};
